import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './static/locales/en.json';
import pl from './static/locales/pl.json';
import { Langs } from './types/GlobalTypes';

export const defaultLang = {
  id: Langs.PL,
  value: Langs.PL.toUpperCase(),
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: defaultLang.id,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      pl: {
        translation: pl,
      },
      en: {
        translation: en,
      },
    },
  });

export default i18n;
